import { Spinner } from "../../shared/ui";

const ACCENT      = "#00C9FF";
const TRUE_COLOR  = "#00cc66";
const FAKE_COLOR  = "#ff3355";

export default function FactOrFakeHost({ fact, answered, result, timeLeft, players, tv }) {
  const fs = (a, b) => tv ? a : b;

  if (!fact) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <Spinner color={ACCENT} tv={tv} />
    </div>
  );

  const timerColor = timeLeft > 5 ? ACCENT : FAKE_COLOR;

  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      gap: fs("1.5rem", "1rem"), padding: fs("2rem", "1rem"),
      maxWidth: "700px", margin: "0 auto", width: "100%",
    }}>

      {/* Таймер */}
      <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
        <div style={{
          width: fs("3.5rem", "2.5rem"), height: fs("3.5rem", "2.5rem"),
          borderRadius: "9999px", background: timerColor,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: fs("1.5rem", "1.1rem"), fontWeight: "bold", color: "#000",
          transition: "background 0.3s", boxShadow: `0 0 16px ${timerColor}`,
        }}>
          {timeLeft}
        </div>
        <span style={{ color: "#aaa", fontSize: fs("1rem", "0.75rem"), fontFamily: "var(--font-body)" }}>
          сек
        </span>
      </div>

      {/* Факт */}
      <div style={{
        background: "#111", border: `2px solid ${ACCENT}`, borderRadius: "1.5rem",
        padding: fs("1.8rem 2rem", "1.2rem 1.2rem"), textAlign: "center",
        fontSize: fs("1.4rem", "1rem"), color: "#fff", fontFamily: "var(--font-heading)",
        lineHeight: 1.4, boxShadow: `0 0 30px ${ACCENT}33`, width: "100%",
      }}>
        {fact}
      </div>

      {/* Результат или ожидание */}
      {result ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: fs("0.8rem", "0.5rem"), width: "100%" }}>

          {/* Правда / Фейк */}
          <div style={{
            background: result.is_true ? `${TRUE_COLOR}22` : `${FAKE_COLOR}22`,
            border: `2px solid ${result.is_true ? TRUE_COLOR : FAKE_COLOR}`,
            borderRadius: "1rem", padding: fs("1rem 2rem", "0.7rem 1.2rem"),
            fontSize: fs("1.5rem", "1.1rem"), fontWeight: "bold",
            color: result.is_true ? TRUE_COLOR : FAKE_COLOR, fontFamily: "var(--font-heading)",
          }}>
            {result.is_true ? "✅ ПРАВДА!" : "❌ ФЕЙК!"}
          </div>

          {/* Объяснение */}
          {result.explanation && (
            <div style={{
              color: "#ddd", fontSize: fs("1.2rem", "0.9rem"), textAlign: "center",
              fontFamily: "var(--font-body)", maxWidth: "560px", lineHeight: 1.5,
              background: "#111", border: "1.5px solid #ffffff22",
              borderRadius: "1rem", padding: fs("1rem 1.5rem", "0.7rem 1rem"),
            }}>
              {result.explanation}
            </div>
          )}

          {/* Игроки */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", justifyContent: "center", marginTop: "0.2rem" }}>
            {players.map(p => {
              const ans = result.answers?.[p.name];
              const isRight = ans === result.is_true;
              return (
                <div key={p.name} style={{
                  background: ans === undefined ? "#222" : isRight ? "#00cc6633" : "#ff335533",
                  border: `1.5px solid ${ans === undefined ? "#444" : isRight ? TRUE_COLOR : FAKE_COLOR}`,
                  borderRadius: "2rem", padding: "0.2rem 0.7rem",
                  fontSize: fs("0.9rem", "0.7rem"),
                  color: ans === undefined ? "#888" : isRight ? TRUE_COLOR : FAKE_COLOR,
                  fontFamily: "var(--font-body)",
                }}>
                  {ans === undefined ? "⏳" : isRight ? "✅" : "❌"} {p.name}
                  {ans !== undefined && (
                    <span style={{ opacity: 0.7, marginLeft: "0.3rem" }}>
                      ({ans ? "Правда" : "Фейк"})
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: fs("0.6rem", "0.4rem"), width: "100%" }}>

          {/* Кнопки-заглушки (только для TV — игроки жмут на телефоне) */}
          <div style={{ display: "flex", gap: fs("2rem", "1rem"), justifyContent: "center" }}>
            <div style={{
              background: `${TRUE_COLOR}22`, border: `2px solid ${TRUE_COLOR}`,
              borderRadius: "1rem", padding: fs("1rem 2.5rem", "0.6rem 1.5rem"),
              fontSize: fs("1.3rem", "1rem"), color: TRUE_COLOR,
              fontFamily: "var(--font-heading)", fontWeight: "bold",
            }}>
              ✅ Правда
            </div>
            <div style={{
              background: `${FAKE_COLOR}22`, border: `2px solid ${FAKE_COLOR}`,
              borderRadius: "1rem", padding: fs("1rem 2.5rem", "0.6rem 1.5rem"),
              fontSize: fs("1.3rem", "1rem"), color: FAKE_COLOR,
              fontFamily: "var(--font-heading)", fontWeight: "bold",
            }}>
              ❌ Фейк
            </div>
          </div>

          {/* Кто уже ответил */}
          {answered.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", justifyContent: "center", marginTop: "0.2rem" }}>
              {answered.map(n => (
                <div key={n} style={{
                  background: `${ACCENT}22`, border: `1.5px solid ${ACCENT}`,
                  borderRadius: "2rem", padding: "0.2rem 0.6rem",
                  fontSize: fs("0.85rem", "0.65rem"), color: ACCENT,
                  fontFamily: "var(--font-body)",
                }}>
                  ✓ {n}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
